import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { getFundingAccountKeyMaker } from "../../Accounts/hooks/useClientFundingAccounts";
import { clientDashboardKeyMaker } from "./useClientDashboard";
export default function useInvalidateClientAccounts() {
    const queryClient = useQueryClient();
    return useCallback(async (clientId) => {
        queryClient.invalidateQueries({
            queryKey: clientDashboardKeyMaker(clientId),
        });
        void queryClient.invalidateQueries({
            queryKey: getFundingAccountKeyMaker(),
        });
    }, [queryClient]);
}
//# sourceMappingURL=useInvalidateClientAccounts.js.map